import axios from "axios";
import {
  getValidTokenRefresh,
  handleGetRequest,
  handleGetToken,
  handlePostRequest
} from "../hooks/api";
import { isTokenValid } from "./jwt";
import { envConfig } from "../config/env";
async function getInterests() {
  const response = await handleGetRequest("/chat/braggable-interests");
  if (response?.error) {
    throw new Error("Error while making get request for braggable interest");
  }
  return response;
}

async function getVibes() {
  const response = await handleGetRequest("/chat/vibes");
  if (response?.error) {
    throw new Error("Error while making get request for braggable interest");
  }
  return response;
}

async function saveProfile(payload) {
  const response = await handlePostRequest(
    "/chat/save-profile",
    payload,
    undefined
  );
  return response;
}

async function fetchProfile() {
  const response = await handleGetRequest("/chat/fetch-profile", undefined);
  if (response?.error) {
    throw new Error("Error while making get request to fetch Profile");
  }
  return response;
}

async function fetchProfiles(payload = {}) {
  const response = await handlePostRequest(
    "/chat/fetch-profiles",
    payload,
    undefined
  );
  return response;
}

async function getGroupsWithConnectedUsers() {
  let token = handleGetToken();

  const geohash = localStorage.getItem("geohash") || "9v6m";
  const payload = { geohash: geohash };
  if (!isTokenValid(token)) {
    token = await getValidTokenRefresh();
  }
  const SERVER_URL = envConfig.chatApiUrl;
  const response = await axios.post(
    `${SERVER_URL}/api/chat/get-groups-with-users`,
    payload,
    {
      headers: {
        Authorization: "Token " + token
      }
    }
  );

  if (response?.error) {
    throw new Error("Error while making get request for chat groups ");
  }
  return response;
}

async function addUserToGroup(payload) {
  let token = handleGetToken();

  if (!isTokenValid(token)) {
    token = await getValidTokenRefresh();
  }
  const SERVER_URL = envConfig.chatApiUrl;
  const response = await axios.post(
    `${SERVER_URL}/api/chat/add-user-to-group`,
    payload,
    {
      headers: {
        Authorization: "Token " + token
      }
    }
  );

  if (response?.error) {
    throw new Error("Error while making get request for chat groups ");
  }
  return response;
}

async function markChatAsRead(roomId) {
  let token = handleGetToken();

  if (!isTokenValid(token)) {
    token = await getValidTokenRefresh();
  }
  const SERVER_URL = envConfig.chatApiUrl;
  const response = await axios.patch(
    `${SERVER_URL}/api/chat/rooms/${roomId}/read`,
    {},
    {
      headers: {
        Authorization: "Token " + token
      }
    }
  );

  if (response?.error) {
    throw new Error("Error while making get request for chat groups ");
  }
  return response;
}

export default {
  getInterests,
  getVibes,
  saveProfile,
  fetchProfile,
  fetchProfiles,
  getGroupsWithConnectedUsers,
  addUserToGroup,
  markChatAsRead
};
